// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c93f2567","703":"22e9d585","787":"f37663e0"}[chunkId] + ".chunk.js";
};